
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This field is deprecated and must be omitted from all inputs.`}</p>
    <p>{`Do not explicitly set to `}<inlineCode parentName="p">{`null`}</inlineCode>{` or any other value.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;